import { Injectable } from '@angular/core';
import { ApiRequestService } from '@core/auth/api-request.service';
import { config } from '@core/interfaces/api_baseurl';
import { BehaviorSubject, EMPTY, forkJoin, Observable, of, switchMap, tap } from 'rxjs';
import { DashCount, KycStage } from './dashboard.types';
import { SprintNextUtilService } from '@core/services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private _kycStatus: BehaviorSubject<KycStage | null> = new BehaviorSubject<KycStage | null>(null);
  private _dashboardCount: BehaviorSubject<DashCount | null> = new BehaviorSubject<DashCount | null>(null);
  defBankId: any = 'first';
  defStatus: any = '1';
  _dashboardDetails = new BehaviorSubject<any>(null);

  get kycStatus$(): Observable<KycStage | null> {
    return this._kycStatus.asObservable();
  }
 
  get kycStatus(): KycStage | null {
    return this._kycStatus.getValue();
  }

  get dashboardCount$(): Observable<DashCount | null> {
    return this._dashboardCount.asObservable();
  }

  get dashboardCount(): DashCount | null {
    return this._dashboardCount.getValue();
  }




  constructor(
    private _ApiRequestService: ApiRequestService,
    private _SprintNextUtilService: SprintNextUtilService
  ) {
    // this._ApiRequestService.postData(config.verify_dashboard.bussniessTrend, new FormData()).subscribe();
  }



  getKycStatus(): Observable<any> {
    return this._ApiRequestService.postData(config.auth.kycStatus).pipe(
      switchMap((r: any) => {

        if (r.statuscode == 200) {
          let { bank_status, kyc_status, account_id }: KycStage = r;
          // let { bank_status, kyc_status, account_id }: KycStage = { bank_status:0, kyc_status:2, account_id:r.account_id };
          this._kycStatus.next({ bank_status, kyc_status, account_id });
        } else {
          r = false;
        }
        return of(r);
      })
    );
  }

  getService(){
    return this._ApiRequestService.postData(config.dashboard.service)
  }
  // getDashboardCount(bank_id: string, date: string[] = []): Observable<any> {
  //   if (bank_id && this.bankId == bank_id) {
  //     return of(this.dashboardCount).pipe(tap(() => {
  //       this._dashboardCount.next(this.dashboardCount);
  //     }));
  //   }
  //   this.bankId = bank_id;
  //   const formData = new FormData();
  //   formData.append('startdate', date[0] ?? '');
  //   formData.append('enddate', date[1] ?? '');
  //   formData.append('id', bank_id);
  //   return this._ApiRequestService.postData(config.verify_dashboard.dashboardData, formData).pipe(
  //     switchMap((r: any) => {
  //       // r = {
  //       //   "code": 200,
  //       //   "responsecode": 1,
  //       //   "status": true,
  //       //   "message": "Dashboard Data fetch.",
  //       //   "data": {
  //       //       "No_of_payIn": 118214,
  //       //       "No_of_payIn_amount": "110798470.00",
  //       //       "No_of_Payments": 543,
  //       //       "No_of_Payments_amount": "5874477.00",
  //       //       "No_of_vaCollection": 0,
  //       //       "No_of_vaCollection_amount": 0
  //       //   }
  //       // }
  //       if (r.code == 200) {
  //         let { No_of_payIn, No_of_payIn_amount, No_of_Payments, No_of_Payments_amount, No_of_vaCollection, No_of_vaCollection_amount  }: DashCount = r.data;
  //         this._dashboardCount.next({ No_of_payIn, No_of_payIn_amount, No_of_Payments, No_of_Payments_amount, No_of_vaCollection, No_of_vaCollection_amount  });
  //       } else {
  //         r = false;
  //       }
  //       return of(r);
  //     })
  //   );
  // }

  getDashboardCount(bank_id: string): Observable<any> {
    if (bank_id && this.defBankId === bank_id) {
      return this._getDashboardCountFromCache();
    }

    this.defBankId = bank_id;
    const formData = this._createFormData(bank_id);
    return this._ApiRequestService.postData(config.verify_dashboard.getAllDashboardStats, formData).pipe(
      switchMap((response: any) => {
        console.log('response', response);
        
        this._dashboardCount.next({
          payoutsData: response.data.payouts,
          va_transactionsData: response.data.va_transactions, 
          merchant_upiData: response.data.merchant_upi,
        });
        return of(true);
      }),
      tap(() => {
        // Ensure a return value in all cases
        return of(false);
      })
    );
  }

  // getDashboardCount(bank_id: string, date: string[] = [], status: string = '1'): Observable<any> {
  //   const formData = this._createFormData(date, bank_id, status);
  //   return forkJoin([
  //     this._ApiRequestService.postData(config.verify_dashboard.dashboardPayoutCount, formData),
  //     this._ApiRequestService.postData(config.verify_dashboard.dashboardVaTxnCount, formData),
  //     this._ApiRequestService.postData(config.verify_dashboard.dashboardUpiCount, formData),
  //   ]).pipe(
  //     switchMap((response: any) => {
  //       if (response.code === 200) {
  //         return this._handleSuccessResponse(response.data);
  //       } else {
  //         return of(false);
  //       }
  //     })
  //   );
  // }

  private _getDashboardCountFromCache(): Observable<any> {
    return of(this.dashboardCount).pipe(tap(() => {
      this._dashboardCount.next(this.dashboardCount);
    }));
  }


  private _createFormData(bank_id: string): FormData {
    const formData = new FormData();
    formData.append('bank_id', bank_id);
    return formData;
  }

  private _handleSuccessResponse(data: DashCount): Observable<any> {
    const {
      payoutsData,
      va_transactionsData,
      merchant_upiData,
     
    } = data;

    this._dashboardCount.next({
      payoutsData,
      va_transactionsData,
      merchant_upiData,
    });

    return of(true);
  }

  notificationContent(){
    return this._ApiRequestService.postData(config.notification.notificationContent)
  }


}


